import { ArrowUpRight } from 'lucide-react';
import { PLATFORM_CARD } from '@/constants/testIds';

export const PlatformCard = ({ platform, index = 0 }) => {
  const ids = PLATFORM_CARD(platform.slug);
  const number = String(index + 1).padStart(2, '0');

  return (
    <a
      href={platform.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={ids.root}
      className="group relative flex flex-col bg-ink-800 border border-white/10 p-8 transition-colors hover:border-amber/50 hover-trace"
    >
      <div className="flex items-start justify-between mb-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
          / {number}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan border border-cyan/30 px-2 py-1">
          {platform.category}
        </span>
      </div>

      <h3 className="font-display text-3xl md:text-4xl text-white mb-2 group-hover:text-amber transition-colors">
        {platform.name}
      </h3>
      <div className="font-mono text-xs uppercase tracking-[0.14em] text-zinc-400 mb-5">
        {platform.tagline}
      </div>

      <p className="text-zinc-300 text-sm leading-relaxed mb-8 flex-1">
        {platform.description}
      </p>

      <div className="flex items-end justify-between pt-6 border-t border-white/10">
        <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-500 max-w-[60%] leading-snug">
          {platform.metric}
        </span>
        <span
          data-testid={PLATFORM_CARD(platform.slug).visit}
          className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-amber group-hover:text-white transition-colors"
        >
          Visit
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </a>
  );
};

export default PlatformCard;
